import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { MonitoringService } from "../../../shared/services";
import { Utils } from "../../../utils/utils";
import { ChartDialogComponent } from "../dialog/chart-dialog.component";
@Component({
  templateUrl: "./activity-list.component.html",
  styleUrls: ["./activity-list.component.css"],
})
export class ActivityListComponent implements OnInit {
  public displayedColumns = [
    "noOfHits",
    "firstRequestOfDay",
    "lastRequestOfDay",
    "serviceName",
    "averageResponseTime",
    "minResponseTime",
    "maxResponseTime",
  ];
  public dataSource = new MatTableDataSource<any>();
  serviceName: string = "";
  userId: string = "";
  apiName: string = "";
  selectedDate: string = "";
  isLoadingResults: boolean = false;
  date = new FormControl(new Date());

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("paginator") paginator: MatPaginator;

  constructor(
    private _monitoringService: MonitoringService,
    private _activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.serviceName = this._activatedRoute.snapshot.queryParams["name"];
    this.userId = this._activatedRoute.snapshot.queryParams["user"];
    this.selectedDate = this._activatedRoute.snapshot.queryParams["date"];
    this.apiName = this._activatedRoute.snapshot.queryParams["api"];
    this.date = new FormControl(this.selectedDate);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.getActivityList(this.selectedDate);
  }

  getActivityList(date) {
    this.isLoadingResults = true;
    if (this.userId) {
      this._monitoringService
        .getUserActivityDetailsforUserId(this.serviceName, date, this.userId)
        .subscribe((data) => {
          this.isLoadingResults = false;
          this.dataSource.data = data.activityList;
        });
    } else {
      this._monitoringService
        .getActivityDetailsforAPIName(this.serviceName, date, this.apiName)
        .subscribe((data) => {
          this.isLoadingResults = false;
          this.dataSource.data = data;
          console.log("data:", data);
        });
    }
  }

  onDateChange(date) {
    this.getActivityList(new Date(date));
  }

  openModel(row) {
    this._monitoringService
      .getApiResponseGraph(
        row["serviceName"],
        this.serviceName,
        this.selectedDate,
        this.userId
      )
      .subscribe((data) => {
        const slicedArray = data.slice(0, 10);
        const top10ResponseTime = slicedArray.map((a) => a.responseTime);
        const top10TimeofHits = slicedArray.map((a) =>
          Utils.formatDate(a.timeofHit)
        );
        this.dialog.open(ChartDialogComponent, {
          disableClose: false,
          data: { "y-axis": top10ResponseTime, "x-axis": top10TimeofHits },
          width: "50%",
          // maxWidth: "100%",
        });
      });
  }

  onRowclick(row) {
    this.openModel(row);
  }
}
